import * as React from 'react'

import { Box, Icon, Popover, Text, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const CycleExplainer = () => {
  const [open, toggle] = useToggle(false)

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
    >
      <Box
        gap="s8"
        alignItems="center"
        cursor="pointer"
        flexDirection="row"
        justifyContent="spaceBetween"
      >
        <Icon.Medium icon="info-circle-line" color="grey800" />
      </Box>
      <Box>
        <Text.Normal>{i18n.t('time_off.new_counter.counter_cycles.tooltip')}</Text.Normal>
      </Box>
    </Popover.ItemList>
  )
}

export default CycleExplainer
